import { Injectable } from '@angular/core';
import { generateFilterId } from '../../../shared/filter-id';

@Injectable({ providedIn: 'root' })
export class FilterIdService {
  generateId(): string {
    return generateFilterId();
  }
}
